import { MessageList } from '@chatscope/chat-ui-kit-react';

const EmptyMessageList = ({ ...props }) => {
    return (
        <MessageList key='2'>
            <MessageList.Content
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    height: '100%',
                    textAlign: 'center',
                    fontSize: '1.2em',
                }}>
                This is custom content placed instead of message list
            </MessageList.Content>
        </MessageList>
    );
};
export default EmptyMessageList;
